import { SoffApiExceptionDto } from '@soff/shared-ui';
import * as LogMessagesActions from './actions';
import { SoffPageDto } from '../../../shared/models/query.model.dto';
import { RelatedInfoSto } from '../../machines/models/machine.model.sto';
import { LogMessageSto } from '../models/log-message.model';

export interface LogMessagePageResultEntry {
  meta: SoffPageDto | null;
  data: LogMessageSto[] | null;
  related: RelatedInfoSto[] | null;
  error: SoffApiExceptionDto | null;
}

/**
 *
 */
export interface LogMessageState {
  pageLoading: boolean;
  pageResult: LogMessagePageResultEntry | null;
}

/**
 *
 */
export const initialState: LogMessageState = {
  pageLoading: false,
  pageResult: null,
};

/**
 *
 * @param state
 * @param action
 * @returns
 */
export function reducer(state = initialState, action: LogMessagesActions.Actions): LogMessageState {
  switch (action.type) {
    //-------------------------------------------------------------------------------------------------------------
    /**
     *
     */
    case LogMessagesActions.LOAD_PAGE:
      return {
        ...state,
        pageLoading: true,
      };

    //-------------------------------------------------------------------------------------------------------------
    /**
     *
     */
    case LogMessagesActions.LOAD_PAGE_FAILURE:
      return {
        ...state,
        pageLoading: false,
      };

    //-------------------------------------------------------------------------------------------------------------
    /**
     *
     */
    case LogMessagesActions.LOAD_PAGE_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        pageResult: {
          meta: {
            loadedAt: new Date(),
            total: action?.payload?.response?.meta?.pagination?.total,
            limit: action?.payload?.pageSize,
            offset: action?.payload?.offset,
            size: action?.payload?.response?.meta?.pagination?.size,
          },
          data: action?.payload?.response?.data,
          related: action?.payload?.response?.related,
          error: null,
        },
      };

    default:
      return state;
  }
}

export const pageLoading = (state: LogMessageState) => state?.pageLoading;
export const pageResult = (state: LogMessageState) => state?.pageResult;
